import { McIcon } from "./icon.js";
import { reg_custom_components } from "../utils/result.js";

export class McIconCloseCircle extends McIcon {
  static elname = "mc-icon-close-circle";

  constructor() {
    super();
    this.template.innerHTML = `
      <svg viewBox="0 0 24 24" width="24"  fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M14.5 9.50002L9.5 14.5M9.49998 9.5L14.5 14.5"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>{" "}
          <path
            d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>{" "}
        </g>
      </svg>
    `;
    super.addHTML(this.template);
  }
}

export class McIconMinusCircle extends McIcon {
  static elname = "mc-icon-minus-circle";

  constructor() {
    super();
    this.template.innerHTML = `
      <svg viewBox="0 0 24 24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M15 12H9"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>{" "}
          <path
            d="M7 3.33782C8.47087 2.48697 10.1786 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.1786 2.48697 8.47087 3.33782 7"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
          ></path>{" "}
        </g>
      </svg>
    `;
    super.addHTML(this.template);
  }
}

reg_custom_components(McIconCloseCircle, McIconMinusCircle);
